// src/components/ui/Input.jsx
const baseCls = [
  'w-full rounded border',
  'border-gray-200 dark:border-[#243348]',
  'bg-white dark:bg-[#0F1923]',
  'text-[var(--wm-text-body)] text-[#0F1923] dark:text-[#F8FAFE]',
  'placeholder:text-[var(--wm-text-ui)] placeholder:text-[#94A3B8] dark:placeholder:text-[#4A6380]',
  'focus:outline-none focus:border-[#2E8BF0] focus:ring-1 focus:ring-[#2E8BF0]/30',
  'transition-colors',
].join(' ');

export function TextInput({ className = '', height = 'h-8', ...props }) {
  return (
    <input
      className={`${baseCls} ${height} px-3 ${className}`}
      {...props}
    />
  );
}

export function SelectInput({ className = '', height = 'h-8', children, ...props }) {
  return (
    <select
      className={`${baseCls} ${height} px-3 pr-8 cursor-pointer appearance-none ${className}`}
      {...props}
    >
      {children}
    </select>
  );
}

export function TextArea({ className = '', rows = 3, ...props }) {
  return (
    <textarea
      rows={rows}
      className={`${baseCls} px-3 py-2 resize-y ${className}`}
      {...props}
    />
  );
}

export default TextInput;
